import Vue from "vue";
import App from "./App.vue";

import Vuelidate from "vuelidate";
import LoggingPlugin from "./lib/logger/LoggingPlugin";

import { debounce } from "./helpers/debounce";
import { createNewEvent } from "./helpers/createNewEvent";

import store from "./helpers/dataStore";

Vue.use(Vuelidate);
Vue.use(LoggingPlugin);
Vue.config.productionTip = false;

Vue.directive("debounce-input", {
    bind: function (el, bind) {
        if (bind.value !== bind.oldValue) {
            // change debounce only if interval has changed
            el.oninput = debounce(function () {
                el.dispatchEvent(createNewEvent("change"));
            }, parseInt(bind.value) || 800);
        }
    },
});

var vueApps = document.getElementsByClassName("vue-app");
for (var i = 0; i < vueApps.length; i++) {
    if (vueApps[i].id && vueApps[i].dataset.mode) {
        new Vue({
            el: "#" + vueApps[i].id,
            store,
            render: (h) =>
                h(App, {
                    props: {
                        id: vueApps[i].id,
                        data: vueApps[i].dataset,
                    },
                }),
        });
    }
}
